import { render, staticRenderFns } from "./FormularioEspecialista.vue?vue&type=template&id=894953e0&lang=pug"
import script from "./FormularioEspecialista.vue?vue&type=script&lang=js"
export * from "./FormularioEspecialista.vue?vue&type=script&lang=js"
import style0 from "./FormularioEspecialista.vue?vue&type=style&index=0&id=894953e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports